import PromptDeleteAction from '@common-components/prompt-delete-action/prompt-delete-action';
import { Column, Gantt, Icons, OnChangeTasks, Task as GanttTask, TitleColumn, ViewMode } from '@common-components/reactgantt';
import { ColumnProps, OnDateChange, OnRelationChange } from '@common-components/reactgantt/types/public-types';
import { PickerProps } from '@common-components/tasks/columns-cells/cell-interface';
import { DateStartEndColumn } from '@common-components/reactgantt/components/task-list/columns/date-start-end-column';
import { PersonColumn } from '@common-components/reactgantt/components/task-list/columns/person-column';
import { ComponentType } from 'react';
import { Gantt as typeGantt } from "@common-models/gantt";
import { DBGanttThunks, ganttSelectOneFieldByQuery } from "@common-reducers/DBServiceThunks";
import { pickerDialogActions } from '@common-reducers/PickerDialogReducer';
import { getGanttTasks } from '@common-reducers/TaskSelectors';
import { moveTaskGroupByDays, updateCellValueThunk, updateGanttOrderTasksByDragableThunk } from '@common-reducers/TaskThunks';
import { UndoRedoAction } from '@common-reducers/UndoRedoReducer';
import { doActionThunk } from '@common-reducers/UndoRedoThunks';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { isEqual } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";


type Props = {
  gantt: typeGantt;
  columnId: string;
  today: any;
  openPopover: any;
}

export default function BTGantt({ gantt, columnId, today, openPopover }: Props) {
  const ganttTasks: GanttTask[] = useAppSelector((state) => getGanttTasks(state, columnId), isEqual);
  const currentDate = new Date();
  const [tasks, setTasks] = useState<GanttTask[]>(ganttTasks);
  const dispatch = useAppDispatch()
  const [arrowTasks, setArrowTasks] = useState<GanttTask[] | undefined>()
  const [deletePromptOpen, setDeletePromptOpen] = useState(false);
  const [fixDependency, setFixDependency] = useState(false);
  const [actionRelation, setActionRelation] = useState<{ payload?: { taskTo?: GanttTask; taskFrom?: GanttTask } } | undefined>();
  const viewMode = useAppSelector(state => ganttSelectOneFieldByQuery(state.DBGanttReducer, { _id: gantt?._id },
    'viewMode'));

  const firstTask = new Date(tasks[0]?.start)
  const x = window.innerHeight - 200

  const icons: Icons = {
    renderAddIcon: () => <>➕</>,
    renderClosedIcon: () => <>📁</>,
    renderDeleteIcon: () => <>➖</>,
    renderEditIcon: () => <>🗃</>,
    renderNoChildrenIcon: () => <></>,
    renderOpenedIcon: () => <>📂</>,
  };

  const widenColumn = (Comp: ComponentType<ColumnProps>) => Comp as ComponentType<ColumnProps & Partial<PickerProps>>;

  const columns: readonly Column[] = [
    {
      component: widenColumn(TitleColumn),
      width: 180,
      title: "Title",
    },
    {
      component: widenColumn(DateStartEndColumn),
      width: 200,
      title: "Task Duration",
    },
    {
      component: widenColumn(PersonColumn),
      width: 100,
      title: "Owner",
    },
  ];
  useEffect(() => {
    // Here render the component because the bag when change view mode
    // setTasks(ganttTasks)
    // openPopover(true)

  }, [viewMode])


  const handleTaskChange: OnDateChange = (taskOrEmpty) => {
    const task = taskOrEmpty as GanttTask;
    function addDays(date: Date, days: number) {
      date.setDate(date.getDate() + days);
      return date;
    }
    // progressPercentage
    let value = {
      startDate: new Date(task?.start),
      endDate: new Date(task?.end),
    }
    if (viewMode === 'Year' || viewMode === 'Month' || viewMode === 'Week') {
      const sameTask = ganttTasks.find(t => t.id === task.id)
      if (sameTask && sameTask.start.getTime() !== task.start.getTime() && sameTask.end.getTime() !== task.end.getTime()) {
        const days = (sameTask.end.getTime() - sameTask.start.getTime()) / (1000 * 3600 * 24)


        value = {
          startDate: new Date(task?.start),
          endDate: new Date(addDays(task?.start, days)),
        }
      }
    }

    if (task.type === 'project') {
      console.log(task.start)
      const projectTask = tasks.find(projTask => projTask.id === task.id)
      if (!projectTask) return;
      const timeDiff = task.start.getTime() - projectTask.start.getTime();
      const daysDiff = timeDiff / (1000 * 3600 * 24);
      const days = Math.round(daysDiff)

      dispatch(moveTaskGroupByDays({
        groupId: task?.id,
        days,
        columnId,
      }));

    }
    else {
      dispatch(updateCellValueThunk({
        taskId: task?.id,
        columnId,
        data: {
          value
        }
      }));
    }
  };



  const handleTasksRelation: OnRelationChange = (taskFrom, taskTo, _isOneDescendant) => {
    console.log(taskFrom)
    const dependenciesList: unknown[] = [];
    const taskToid = taskTo[0].id;
    void gantt.tasksDependencies;
    console.log(taskTo)

    // task from id
    const sourceId = taskFrom[0].id;
    // task from indicate
    const sourceTarget = taskFrom[1]
    // task to indicate
    const ownTarget = taskTo[1]

    const dependenciesTask = {
      sourceId,
      sourceTarget,
      ownTarget
    }

    console.log(dependenciesTask)
    if ((sourceId! == undefined && sourceTarget !== undefined && ownTarget !== undefined) || taskTo[0].id !== sourceId) {

      const taskToAddDependecies = tasks.filter((task) => task.id === taskToid)
      const firstDep = taskToAddDependecies[0];
      if (firstDep && firstDep.dependencies) {
        (firstDep.dependencies as unknown[])[0] = dependenciesTask;
      }
      const newTasks = [...tasks]
      setTasks(newTasks)
      dependenciesList.push(dependenciesTask)
      dispatch(
        DBGanttThunks.patch({
          entity: {
            ...gantt,
            tasksDependencies: {
              ...gantt?.tasksDependencies,

              [taskToid]: dependenciesTask
            }
          }
        })
      )
    } else {
      console.warn('gantt dependency error')
    }

  }
  useEffect(() => {
    setTasks(ganttTasks)

  }, [ganttTasks])


  const onChangeHandle = useCallback<OnChangeTasks>((nextTasks, action) => {

    console.log('action.type')
    console.log(action.type)
    console.log(action)

    switch (action.type) {
      case 'fix_dependency_position': {

        const taskHasClicked = action.payload.task;
        const taskToDependent = action.payload.dependentTasks;


        const dependetToTaskHasClicked = taskToDependent.find((task: GanttTask) => task?.dependencies?.[0]?.sourceId === taskHasClicked.id)
        console.log(dependetToTaskHasClicked)

        break;
      }
      case 'relation_change': {

        const newTsaks2: GanttTask[] = [...nextTasks] as GanttTask[]
        console.log(newTsaks2)
        setTasks(newTsaks2)
        break
      }
      case 'delete_relation_open_menu': {
        const deleteArrowTasks: GanttTask[] = [...nextTasks] as GanttTask[]
        setDeletePromptOpen(true);
        setActionRelation({ payload: action.payload })
        setArrowTasks(deleteArrowTasks)
        break;
      }
      case "delete_relation":
        break;
      case 'date_change': {

        const newTasksChanges: GanttTask[] = [...nextTasks] as GanttTask[]
        setTasks(newTasksChanges)

        break;
      }
      case 'move_task_after': {

        const tasksOrder: Array<Record<string, number>> = []
        const newTasks: GanttTask[] = [...nextTasks] as GanttTask[];
        newTasks.map((task, index) => {
          const taskOrder = {
            [task.id]: index
          }
          tasksOrder.push(taskOrder)
        })


        if (gantt._id) {
          dispatch(
            DBGanttThunks.patch({
              entity: {
                _id: gantt._id,
                tasksOrder: [...tasksOrder]
              }
            })
          )
        }


        dispatch(updateGanttOrderTasksByDragableThunk({ originalTaskList: tasks, newTaskList: newTasks, gantt: gantt }));
        setTasks(newTasks)
        break;
      }
      case 'move_task_inside':
        break;
      default: {
        const defaultTasks: GanttTask[] = [...nextTasks] as GanttTask[]
        setTasks(defaultTasks)
      }
    }
  }, []);

  const handleColumnWidth = () => {
    switch (viewMode) {
      case 'Day':
        return 55
        break;
      case 'Week':
        return 120
        break;
      case 'Month':
        return 150
        break;
      case 'Year':
        return 600
        break;
    }
  }


  const handleFixDependency: OnDateChange = (taskOrEmpty) => {
    const task = taskOrEmpty as GanttTask;
    const value = {
      startDate: new Date(task?.start),
      endDate: new Date(task?.end),
    }
    dispatch(
      DBGanttThunks.patch({
        entity: {
          ...gantt,
          fixDependency: true
        }
      })
    )


    dispatch(updateCellValueThunk({
      taskId: task?.id,
      columnId,
      data: {
        value
      }
    }));

    dispatch(
      DBGanttThunks.patch({
        entity: {
          ...gantt,
          fixDependency: false
        }
      })
    )


    // dispatch(
    //   DBGanttThunks.patch({
    //     entity: {
    //       ...gantt,
    //       fixDependency: false
    //     }
    //   })
    // )

  }

  const handleDeleteConfirmationClosed = (shouldDelete?: boolean) => {
    if (shouldDelete === true) {


      const cloneDependencies: Record<string, unknown> = { ...(gantt.tasksDependencies ?? {}) as Record<string, unknown> }
      const deleteId = actionRelation?.payload?.taskTo?.id
      if (deleteId) {
        delete cloneDependencies[deleteId]
      }


      dispatch(
        DBGanttThunks.patch({
          entity: {
            ...gantt,
            tasksDependencies: cloneDependencies
          }
        })
      )
      if (arrowTasks) setTasks(arrowTasks)

    }
    const action: UndoRedoAction<string[], string> = {
      type: 'delete-arrow-relation',
      data: [(gantt._id ?? '').toString()],
      deletedOrArchived:"deleted"
    }
    dispatch(doActionThunk({ action }),)
    setDeletePromptOpen(false)
    // dispatch(pickerDialogActions.closePickerDialog())
  }

  const handlePreStepsCount = () => {
    switch (viewMode) {
      case 'Day':
        return 45
        break;
      case 'Week':
        return 20
        break;
      case 'Month':
        return 2
        break;
      case 'Year':
        return 2
        break;
    }
  }
  return (
    <div>


      {ganttTasks.length > 0 ?

        <DndProvider backend={HTML5Backend}>
          <Gantt
            //  onChangeTasks={handleTaskChange}
            isShowDependencyWarnings={true}
            viewDate={today ?? firstTask}
            preStepsCount={handlePreStepsCount()}

            colors={{ todayColor: 'var(--color-text)' }}
            distances={{ columnWidth: handleColumnWidth(),barCornerRadius:10,ganttHeight: x}}
            viewMode={gantt.viewMode ?? ViewMode.Day}
            
            OnFirstEndTaskChange={(t) => handleTaskChange(t, [], 0, [], [])}
            tasks={ganttTasks}
            icons={icons}
            columns={columns}
            onFixDependencyPosition={handleFixDependency}
            isShowTaskNumbers={false}
            onChangeTasks={onChangeHandle}
            onRelationChange={handleTasksRelation}
          // onClick={(e)=>openPopover2}
          // onTaskClick={(task)=>{console.log(task)}}
          />
        </DndProvider>
        : <h1>there is no value in timeline columns</h1>}

      {<PromptDeleteAction title={`Delete relation between ${actionRelation?.payload?.taskFrom?.name} to ${actionRelation?.payload?.taskTo?.name} ?`} handleClose={handleDeleteConfirmationClosed} open={deletePromptOpen} />}
      {<PromptDeleteAction title={`do you want to fix all dependency? ?`} handleClose={() => setFixDependency(false)} open={fixDependency} />}
    </div>
  )
}